import type { Partner, PartnerCategory, PartnerStatus, PartnerType } from './types';

export const PARTNER_CATEGORIES: { value: PartnerCategory; labelKey: string; color: string }[] = [
  { value: 'retail', labelKey: 'partner.category.retail', color: 'bg-blue-100 text-blue-800' },
  {
    value: 'wholesale',
    labelKey: 'partner.category.wholesale',
    color: 'bg-purple-100 text-purple-800',
  },
  { value: 'rental', labelKey: 'partner.category.rental', color: 'bg-green-100 text-green-800' },
  {
    value: 'service',
    labelKey: 'partner.category.service',
    color: 'bg-orange-100 text-orange-800',
  },
  { value: 'supplier', labelKey: 'partner.category.supplier', color: 'bg-red-100 text-red-800' },
  {
    value: 'contractor',
    labelKey: 'partner.category.contractor',
    color: 'bg-gray-100 text-gray-800',
  },
];

export const PARTNER_STATUSES: { value: PartnerStatus; labelKey: string; color: string }[] = [
  {
    value: 'active',
    labelKey: 'partner.status.active',
    color: 'bg-green-100 text-green-800 dark:bg-green-900/30 dark:text-green-300',
  },
  {
    value: 'trusted',
    labelKey: 'partner.status.trusted',
    color: 'bg-blue-100 text-blue-800 dark:bg-blue-900/30 dark:text-blue-300',
  },
  {
    value: 'warning',
    labelKey: 'partner.status.warning',
    color: 'bg-yellow-100 text-yellow-800 dark:bg-yellow-900/30 dark:text-yellow-300',
  },
  {
    value: 'inactive',
    labelKey: 'partner.status.inactive',
    color: 'bg-gray-100 text-gray-800 dark:bg-gray-800/50 dark:text-gray-300',
  },
  {
    value: 'blocked',
    labelKey: 'partner.status.blocked',
    color: 'bg-red-100 text-red-800 dark:bg-red-900/30 dark:text-red-300',
  },
];

export const PARTNER_TYPES: { value: PartnerType; labelKey: string }[] = [
  { value: 'individual', labelKey: 'partner.type.individual' },
  { value: 'company', labelKey: 'partner.type.company' },
];

export const MOCK_PARTNERS: Partner[] = [
  {
    id: 'p-001',
    type: 'company',
    status: 'active',
    categories: ['rental', 'service'],
    code: 'P-0001',
    taxNumber: '12345678-2-42',
    registrationNumber: '01-09-123456',
    name: 'Kovács és Társa Kft.',
    shortName: 'Kovács Kft.',
    email: 'info@kovacskft.hu',
    phone: '+36 1 234 5678',
    website: 'https://kovacskft.hu',
    addresses: [
      {
        id: 'a-001',
        type: 'billing',
        isDefault: true,
        country: 'Magyarország',
        postalCode: '1134',
        city: 'Budapest',
        street: 'Váci út 35.',
        building: '3. emelet',
      },
    ],
    contacts: [
      {
        id: 'c-001',
        name: 'Kovács János',
        position: 'Ügyvezető',
        email: 'kovacs.janos@kovacskft.hu',
        phone: '+36 30 123 4567',
        isPrimary: true,
      },
      {
        id: 'c-002',
        name: 'Nagy Éva',
        position: 'Beszerzés',
        email: 'nagy.eva@kovacskft.hu',
        phone: '+36 30 234 5678',
        isPrimary: false,
      },
    ],
    paymentTermDays: 30,
    creditLimit: 500000,
    discountPercent: 5,
    discountRental: 5,
    discountSales: 3,
    discountService: 2,
    rentalDepositPercent: 20,
    rentalBlocked: false,
    notes: 'Megbízható partner, rendszeres bérlő.',
    stats: {
      totalOrders: 45,
      totalRevenue: 2850000,
      totalRentals: 23,
      totalServiceOrders: 8,
      lastOrderDate: '2026-01-15',
      lastRentalDate: '2026-01-10',
      outstandingBalance: 125000,
    },
    createdAt: '2024-03-15T10:00:00Z',
    updatedAt: '2026-01-15T14:30:00Z',
    createdBy: 'admin',
  },
  {
    id: 'p-002',
    type: 'individual',
    status: 'active',
    categories: ['retail', 'rental'],
    code: 'P-0002',
    name: 'Szabó Péter',
    email: 'szabo.peter@gmail.com',
    phone: '+36 70 987 6543',
    addresses: [
      {
        id: 'a-002',
        type: 'billing',
        isDefault: true,
        country: 'Magyarország',
        postalCode: '2030',
        city: 'Érd',
        street: 'Fő utca 12.',
      },
    ],
    contacts: [],
    paymentTermDays: 0,
    rentalDepositPercent: 30,
    rentalBlocked: false,
    stats: {
      totalOrders: 12,
      totalRevenue: 485000,
      totalRentals: 5,
      totalServiceOrders: 2,
      lastOrderDate: '2026-01-08',
      lastRentalDate: '2025-12-20',
      outstandingBalance: 0,
    },
    createdAt: '2024-06-20T08:00:00Z',
    updatedAt: '2026-01-08T11:15:00Z',
    createdBy: 'admin',
  },
  {
    id: 'p-003',
    type: 'company',
    status: 'active',
    categories: ['wholesale', 'service'],
    code: 'P-0003',
    taxNumber: '98765432-2-13',
    registrationNumber: '13-09-654321',
    name: 'Építőipari Megoldások Zrt.',
    shortName: 'ÉpMeg Zrt.',
    email: 'rendeles@epmeg.hu',
    phone: '+36 1 555 1234',
    website: 'https://epmeg.hu',
    addresses: [
      {
        id: 'a-003',
        type: 'billing',
        isDefault: true,
        country: 'Magyarország',
        postalCode: '2040',
        city: 'Budaörs',
        street: 'Gyár utca 88.',
      },
      {
        id: 'a-004',
        type: 'shipping',
        isDefault: false,
        country: 'Magyarország',
        postalCode: '2045',
        city: 'Törökbálint',
        street: 'Raktár köz 5.',
      },
    ],
    contacts: [
      {
        id: 'c-003',
        name: 'Tóth Gábor',
        position: 'Műszaki igazgató',
        email: 'toth.gabor@epmeg.hu',
        phone: '+36 20 555 1111',
        isPrimary: true,
      },
    ],
    paymentTermDays: 45,
    creditLimit: 2000000,
    discountPercent: 10,
    discountRental: 10,
    discountSales: 8,
    discountService: 5,
    rentalDepositPercent: 15,
    rentalBlocked: false,
    notes: 'VIP partner, nagyker árazás.',
    stats: {
      totalOrders: 156,
      totalRevenue: 18500000,
      totalRentals: 42,
      totalServiceOrders: 35,
      lastOrderDate: '2026-01-17',
      lastRentalDate: '2026-01-12',
      outstandingBalance: 850000,
    },
    createdAt: '2023-01-10T09:00:00Z',
    updatedAt: '2026-01-17T16:45:00Z',
    createdBy: 'admin',
  },
  {
    id: 'p-004',
    type: 'company',
    status: 'blocked',
    categories: ['rental'],
    code: 'P-0004',
    taxNumber: '11223344-2-41',
    name: 'Probléma Bt.',
    email: 'info@problema.hu',
    phone: '+36 1 111 2222',
    addresses: [
      {
        id: 'a-005',
        type: 'billing',
        isDefault: true,
        country: 'Magyarország',
        postalCode: '1111',
        city: 'Budapest',
        street: 'Rossz utca 1.',
      },
    ],
    contacts: [],
    paymentTermDays: 8,
    creditLimit: 0,
    rentalDepositPercent: 100,
    rentalBlocked: true,
    notes: 'TILTOTT - fizetési problémák miatt',
    internalNotes: '2025-ben 3 hónapos tartozás, végül végrehajtás útján behajtva.',
    stats: {
      totalOrders: 8,
      totalRevenue: 320000,
      totalRentals: 3,
      totalServiceOrders: 0,
      lastOrderDate: '2025-06-15',
      lastRentalDate: '2025-05-01',
      outstandingBalance: 0,
    },
    createdAt: '2024-08-01T10:00:00Z',
    updatedAt: '2025-09-01T12:00:00Z',
    createdBy: 'admin',
  },
  {
    id: 'p-005',
    type: 'company',
    status: 'active',
    categories: ['supplier'],
    code: 'P-0005',
    taxNumber: '55667788-2-42',
    euVatNumber: 'HU55667788',
    registrationNumber: '01-09-888777',
    name: 'Makita Magyarország Kft.',
    shortName: 'Makita',
    email: 'rendeles@makita.hu',
    phone: '+36 1 888 9999',
    website: 'https://makita.hu',
    addresses: [
      {
        id: 'a-006',
        type: 'billing',
        isDefault: true,
        country: 'Magyarország',
        postalCode: '1138',
        city: 'Budapest',
        street: 'Makita park 1.',
      },
    ],
    contacts: [
      {
        id: 'c-004',
        name: 'Horváth Miklós',
        position: 'Értékesítési vezető',
        email: 'horvath.miklos@makita.hu',
        phone: '+36 30 888 1234',
        isPrimary: true,
      },
    ],
    paymentTermDays: 60,
    rentalBlocked: false,
    notes: 'Fő beszállító - elektromos szerszámok',
    stats: {
      totalOrders: 0,
      totalRevenue: 0,
      totalRentals: 0,
      totalServiceOrders: 0,
      outstandingBalance: 0,
    },
    createdAt: '2023-01-01T08:00:00Z',
    updatedAt: '2025-12-01T10:00:00Z',
    createdBy: 'admin',
  },
  {
    id: 'p-006',
    type: 'individual',
    status: 'inactive',
    categories: ['retail'],
    code: 'P-0006',
    name: 'Kiss László',
    phone: '+36 30 111 2233',
    addresses: [
      {
        id: 'a-007',
        type: 'billing',
        isDefault: true,
        country: 'Magyarország',
        postalCode: '3300',
        city: 'Eger',
        street: 'Dobó tér 5.',
      },
    ],
    contacts: [],
    paymentTermDays: 0,
    rentalBlocked: false,
    stats: {
      totalOrders: 2,
      totalRevenue: 45000,
      totalRentals: 0,
      totalServiceOrders: 1,
      lastOrderDate: '2024-03-20',
      outstandingBalance: 0,
    },
    createdAt: '2024-03-18T14:00:00Z',
    updatedAt: '2024-03-20T09:30:00Z',
    createdBy: 'admin',
  },
  {
    id: 'p-007',
    type: 'company',
    status: 'active',
    categories: ['rental', 'retail', 'service'],
    code: 'P-0007',
    taxNumber: '44556677-2-07',
    registrationNumber: '07-09-112233',
    name: 'Dunántúli Építők Kft.',
    shortName: 'DunÉp',
    email: 'info@dunep.hu',
    phone: '+36 96 123 456',
    addresses: [
      {
        id: 'a-008',
        type: 'billing',
        isDefault: true,
        country: 'Magyarország',
        postalCode: '9021',
        city: 'Győr',
        street: 'Révai utca 10.',
      },
    ],
    contacts: [
      {
        id: 'c-005',
        name: 'Molnár Ferenc',
        position: 'Tulajdonos',
        email: 'molnar@dunep.hu',
        phone: '+36 70 456 7890',
        isPrimary: true,
      },
    ],
    paymentTermDays: 30,
    creditLimit: 1000000,
    discountPercent: 8,
    discountRental: 8,
    discountSales: 6,
    discountService: 4,
    rentalDepositPercent: 20,
    rentalBlocked: false,
    stats: {
      totalOrders: 78,
      totalRevenue: 6200000,
      totalRentals: 31,
      totalServiceOrders: 15,
      lastOrderDate: '2026-01-16',
      lastRentalDate: '2026-01-14',
      outstandingBalance: 280000,
    },
    createdAt: '2023-06-01T10:00:00Z',
    updatedAt: '2026-01-16T15:20:00Z',
    createdBy: 'admin',
  },
  {
    id: 'p-008',
    type: 'company',
    status: 'active',
    categories: ['contractor'],
    code: 'P-0008',
    taxNumber: '33445566-1-43',
    name: 'Villanyász Mester Bt.',
    email: 'villanyasz@freemail.hu',
    phone: '+36 20 333 4455',
    addresses: [
      {
        id: 'a-009',
        type: 'billing',
        isDefault: true,
        country: 'Magyarország',
        postalCode: '1048',
        city: 'Budapest',
        street: 'Villám utca 22.',
      },
    ],
    contacts: [
      {
        id: 'c-006',
        name: 'Varga István',
        position: 'Mester',
        email: 'varga.istvan@villanyasz.hu',
        phone: '+36 20 333 4455',
        isPrimary: true,
      },
    ],
    paymentTermDays: 15,
    rentalBlocked: false,
    notes: 'Alvállalkozó - elektromos munkák',
    stats: {
      totalOrders: 5,
      totalRevenue: 180000,
      totalRentals: 0,
      totalServiceOrders: 0,
      lastOrderDate: '2025-11-20',
      outstandingBalance: 0,
    },
    createdAt: '2025-05-01T09:00:00Z',
    updatedAt: '2025-11-20T14:00:00Z',
    createdBy: 'admin',
  },
];
